import { render, staticRenderFns } from "./contentproviderscomponent.vue?vue&type=template&id=4f76b781&"
import script from "./contentproviderscomponent.vue?vue&type=script&lang=ts&"
export * from "./contentproviderscomponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports